import AspectRatioBox from '../../../common/component/AspectRatioBox';
import ContentCardBodyV4 from '../../../common/component/ContentCardBodyV4';
import {DEFAULT_ASPECT_RATIO} from '../../../common/constant';
import useSplitAdultBadgeList from '../../../common/hook/useSplitAdultBadgeList';
import {routeTo} from '../../../common/util/PageRouter';
import RankingInfo from '../../main/component/RankingInfo';
import {IMainContent} from '../type';

interface IProps {
  content: IMainContent;
  showRankingInfo: boolean;
  index: number;
  onClickContent?: () => void;
  onSendViewImpContent?: () => void;
}
export default function GridModuleContentCard({
  content,
  showRankingInfo,
  index,
  onClickContent,
  onSendViewImpContent,
}: IProps) {
  const {ranking, delta, badges, landingUrl, isEvent, bgColor} = content;
  const {adultBadges, otherBadges} = useSplitAdultBadgeList(badges);
  const contentProp = showRankingInfo
    ? {...content, badges: otherBadges}
    : content;

  return (
    <AspectRatioBox
      aspectRatio={DEFAULT_ASPECT_RATIO}
      style={isEvent && bgColor ? {backgroundColor: bgColor} : undefined}
      wrapperClassName="rounded-8"
    >
      <ContentCardBodyV4
        index={index}
        content={contentProp}
        landingUrl={landingUrl}
        onClick={() => {
          onClickContent?.();
          landingUrl && routeTo(landingUrl);
        }}
        cardInfoClassName={showRankingInfo ? '!bottom-34' : undefined}
        additionalElement={
          showRankingInfo ? (
            <RankingInfo ranking={ranking} delta={delta} badges={adultBadges} />
          ) : undefined
        }
        onIntersection={isIntersecting =>
          isIntersecting && onSendViewImpContent?.()
        }
      />
    </AspectRatioBox>
  );
}
